import React, { useContext, useState, useEffect } from 'react';
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DatePicker, { registerLocale } from "react-datepicker";
import DownloadLink from "../_shared/DownloadLink";
import EditTitle from '../_shared/EditTitle';
import Icon from '../_shared/Icon';
import PopUp from '../_shared/PopUp';
import { Context } from '../../commons/context';
import JwtInterceptor from '../_shared/JwtInterceptors';
import pl from "date-fns/locale/pl";
registerLocale("pl", pl);

const API_URL = process.env.REACT_APP_API_URL;

const ProfileCard = () => {
  const { t } = useTranslation();
  const [data, setData] = useContext(Context);
  const [isEdit, setIsEdit] = useState(false);
  const {control, register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
  const [loader, setLoader] = useState(false);
  const [popUp, setPopUp] = useState(false);
  const [popUpText, setPopUpText] = useState('');
  const [popUpType, setPopUpType] = useState('');
  const formData = {}

  useEffect(() => {
    if (data.user.cardNumberExpiry) {
      setValue('cardExpiry', new Date(data.user.cardNumberExpiry));
    } else {
      setValue('cardExpiry', '');
    }
  }, [data.user.cardNumberExpiry, isEdit]);

  const onSubmit = async (sendData) => {
    if (!loader) {
      setLoader(true);

      const date = new Date(sendData.cardExpiry);
      date.setDate(date.getDate() + 1);

      formData.cardNumber = data.user.cardNumber;
      formData.cardNumberExpiry = date.toISOString();

      JwtInterceptor
          .put(`${API_URL}Users/card?uid=${data.user.id}`, formData)
          .then((response) => {
            setPopUpText(t('dataChangeSuccess'));
            setPopUpType('success');

            setData({
              type: 'SET_USER',
              payload: {
                ...data.user,
                cardNumberExpiry: sendData.cardExpiry
              },
            });
          })
          .catch(function (error) {
            if (error.response.data.errors) {
              const errorTxt = error.response.data.errors.message.map(error => <p>{error}</p>);
              setPopUpText(errorTxt);
            } else {
              setPopUpText(t('errDefault'));
            }
            setPopUpType('error');
          }).finally(() => {
        setLoader(false);
        setPopUp(true);
        setIsEdit(false);
      });
    }
  };

  const editHandler = (e) => {
    e.preventDefault();
    setIsEdit(prevState => !prevState);
    reset();
  }

  const popUpCloseHandler = () => {
    setPopUp(false);
  }

  return (
      <div>
        <EditTitle editLinkText={t('edit')} text={t('myCard')} editFnc={(e) => editHandler(e)} isEdit={isEdit} isLoading={loader} sendFnc={handleSubmit(onSubmit)} />
        <img className="max-h-40 mb-5" src="/images/cardImg.png" alt="card" />
        <form className="w-full mb-10">
          <p className="flex text-base w-full">
            <span className="inline-block font-nouvelrbold w-6/12 md:w-4/12">{t('cardNumber')}</span>
            <span className="inline-block w-6/12 md:w-8/12">{data.user.cardNumber ? data.user.cardNumber : '-'}</span>
          </p>
          <div className='flex text-base w-full mt-4'>
            <span className="inline-block font-nouvelrbold w-6/12 md:w-4/12">{t('cardExpiry')}</span>
            {/*<input type="text" {...register("cardExpiry", { required: true, disabled: !isEdit, maxLength: 40, pattern: /^[^\s]+[^^<>&]{2,50}$/i})} defaultValue={data.user.cardNumberExpiry ? data.user.cardNumberExpiry : ''} maxLength="40" className={`inline-block w-6/12 md:w-8/12 outline-none bg-white border-b border-solid ${isEdit ? 'border-formBorder' : 'border-white'}`} />*/}
            <div className="inline-block w-6/12 md:w-8/12 datepicker-full">
              <Controller
                  name="cardExpiry"
                  control={control}
                  // defaultValue={date}
                  errors={errors}
                  rules={{ required: true }}
                  render={({ field: { onChange, value} }) => (
                      <DatePicker
                          type="text"
                          id="dateFrom"
                          placeholder=" "
                          dateFormat="MM/yy"
                          className={`w-full outline-none bg-white border-b border-solid ${isEdit ? 'border-formBorder' : 'border-white'}`}
                          selected={value}
                          onChange={
                            (date) => {
                              onChange(date);
                            }
                          }
                          readOnly={!isEdit}
                          showMonthYearPicker
                          locale="pl"
                      />
                  )}
              />
            </div>
          </div>
          {!data.user.cardNumberExpiry &&
              <p className="flex text-base w-full mt-1 text-error">{t('cardExpiryInfo')}</p>
          }
          {errors.cardExpiry && errors.cardExpiry.type === "required" && <span className="text-error">{t('errFieldRequired')}</span>}
          {errors.cardExpiry && errors.cardExpiry.type === "pattern" && <span className="text-error">{t('errFieldValue')}</span>}
          {data.user.cardBalance &&
            <p className="flex text-base mt-4">
              <span className="inline-block font-nouvelrbold w-6/12 md:w-4/12">{t('cardBalance')}</span>
              <span className="inline-block w-6/12 md:w-8/12">{data.user.cardBalance} zł</span>
            </p>
          }
          <p className="py-4 mt-4">
            <DownloadLink text={t('cardRulesDownloadAnchor')}  link="/pdf/eprl_regulamin_uzytkowania_przedplaconej_karty_edenred_11_03_2024_PL.pdf" />
          </p>
          <p>
            <DownloadLink text={t('howCartActivate')} link="/pdf/card_neut_std_2_druk.pdf" />
          </p>
          <p className="mt-5 mb-5">
            <a href="https://nowy.myedenred.pl/" rel="noreferrer" target="_blank" className="flex items-center font-semibold transition ease-in-out duration-300 stroke-black hover:text-brand">
              {t('checkCardStatus')}
              <Icon id="leftArr" viewBox="0 0 22 21" width="22" height="21" clsWrap="ml-4 rotate-180	" />
            </a>
          </p>
        </form>
        <PopUp open={popUp} text={popUpText} type={popUpType} hideFnc={popUpCloseHandler} />
      </div>
  );
}

export default ProfileCard;